import { render, staticRenderFns } from "./Blockie.vue?vue&type=template&id=4489eb88&scoped=true&"
import script from "./Blockie.vue?vue&type=script&lang=js&"
export * from "./Blockie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4489eb88",
  null
  
)

export default component.exports